import styled from "styled-components";

const VersionPanelContainer = styled.div`
  position: fixed;
  padding: 6px;
  bottom: 0;
  left: 0;
  background-color: #efefef;
  -webkit-box-shadow: 0px 0px 5px 2px rgba(221, 221, 221, 1);
  -moz-box-shadow: 0px 0px 5px 2px rgba(221, 221, 221, 1);
  box-shadow: 0px 0px 5px 2px rgba(221, 221, 221, 1);
`;

export default function VersionPanel() {
  return (
    <VersionPanelContainer>
      Current Version {process.env.REACT_APP_VERSION}
    </VersionPanelContainer>
  );
}
